module.exports = "/_next/static/media/016e29656c6da8778f08df22d079b3d0.png";